import { useState } from "react";
import { createPortal } from "react-dom";
import Icons from ".";
import Alert from "../ConfirmBox/Alert";

export const NewResultIcon = () => {

    return (
        <>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="7.16667" y="1.66675" width="6.66667" height="3.33333" rx="1" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.8333 3.33325H15.5C16.4205 3.33325 17.1667 4.07944 17.1667 4.99992V15.8333C17.1667 16.7537 16.4205 17.4999 15.5 17.4999H5.49999C4.57952 17.4999 3.83333 16.7537 3.83333 15.8333V4.99992C3.83333 4.07944 4.57952 3.33325 5.49999 3.33325H7.16666" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.16667 14.5834H13.8333" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.8333 12.0834H7.16667" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 9.58325V7.08325" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.75 8.33341H9.25002" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};


export const NewCompaniesIcon = () => {

    return (
        <>
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 16.5001V9.00008C2 8.53984 2.3731 8.16675 2.83333 8.16675H5.33333" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8.66666 5.66676V2.75123C8.66666 2.34126 8.86769 1.95734 9.20466 1.72382C9.54163 1.4903 9.97169 1.43686 10.3556 1.58081L16.4593 3.86971C16.7845 3.99168 17 4.30261 17 4.64998V16.5001" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.33333 16.5001V6.50008C5.33333 6.03984 5.70642 5.66675 6.16666 5.66675H12C12.4602 5.66675 12.8333 6.03984 12.8333 6.50008V16.5001" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.8333 16.5002H1.16666" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.83331 13.5834H10.3333" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.83331 11.0834H10.3333" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.83331 8.58341H10.3333" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};

export const NewDasboardIcon = () => {

    return (
        <>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.035 6.9158L12.035 3.02663C11.1325 2.32413 9.86833 2.32413 8.965 3.02663L3.965 6.9158C3.35583 7.38913 3 8.11746 3 8.88913V15C3 16.3808 4.11917 17.5 5.5 17.5H15.5C16.8808 17.5 18 16.3808 18 15V8.88913C18 8.11746 17.6442 7.38913 17.035 6.9158Z" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" />
                <path d="M8 14.1667H13" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};


export const NewReportsIcon = () => {

    return (
        <>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.49792 9.16635H10.5" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.49792 6.66538H7.99896" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.74844 14.1685V14.1685C6.0579 14.1683 5.49817 13.6085 5.49792 12.918V12.918C5.49817 12.2275 6.0579 11.6677 6.74844 11.6675V11.6675C7.43898 11.6677 7.99871 12.2275 7.99896 12.918V12.918C7.99871 13.6085 7.43898 14.1683 6.74844 14.1685V14.1685Z" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9168 14.377H13.001V17.5033H10.9168C10.6866 17.5033 10.5 17.3166 10.5 17.0864V14.7938C10.5 14.5636 10.6866 14.377 10.9168 14.377Z" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4179 10.8337H15.0852C15.3155 10.8337 15.5021 11.0204 15.5021 11.2506V17.5032H13.001V11.2506C13.001 11.0204 13.1877 10.8337 13.4179 10.8337Z" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9189 12.7095H17.5863C17.8165 12.7095 18.0031 12.8961 18.0031 13.1263V17.0863C18.0031 17.3165 17.8165 17.5031 17.5863 17.5031H15.5021V13.1263C15.5021 12.8961 15.6887 12.7095 15.9189 12.7095Z" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.99896 17.5033H4.66424C3.74338 17.5033 2.99688 16.7568 2.99688 15.836V4.16443C2.99688 3.24357 3.74338 2.49707 4.66424 2.49707H11.4767C11.9189 2.49707 12.343 2.67274 12.6557 2.98543L15.0137 5.34343C15.3264 5.65612 15.5021 6.08022 15.5021 6.52244V8.33283" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};
export const NewBillingIcon = () => {
    return (
        <>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.1667 17.5V3.74793C17.1667 3.43289 16.989 3.14478 16.7075 3.00333L15.8825 2.58873C15.6488 2.47127 15.3734 2.47038 15.1389 2.58634L13.8285 3.23433L12.5444 2.58927C12.31 2.47151 12.0338 2.47101 11.799 2.58792L10.5 3.23459L9.20103 2.58792C8.96618 2.47101 8.68999 2.47151 8.45556 2.58927L7.17148 3.23433L5.86108 2.58634C5.62659 2.47038 5.35125 2.47127 5.11751 2.58873L4.29251 3.00333C4.01101 3.14478 3.83334 3.43289 3.83333 3.74793V17.5" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.9992 13.3334L13.8325 13.3335" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.8333 10.4167L13 10.4166" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.16667 13.3334H10.5" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 10.4167H7.16667" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.8333 7.50016H7.16667" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.8333 17.4999H2.16667" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );
};

export const NewAppointmentsIcon = ({ height = "18",width="17", color }) => {

    return (
        <>
            <svg width={width} height={height} viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.74998 1.5V4" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.25 1.5V4" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16 7.33341H1" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <rect x="1" y="2.75" width="15" height="13.75" rx="3" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};

export const NewPatientsIcon = ({ height = "20", width = "21", color }) => {

    return (
        <>
            <svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.1667 11.6667H8.83332C7.91285 11.6667 7.16666 12.4129 7.16666 13.3334" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <ellipse cx="10.5" cy="7.70825" rx="1.875" ry="1.875" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 5.83325C11.5355 5.83325 12.375 6.67272 12.375 7.70825C12.375 8.74379 11.5355 9.58325 10.5 9.58325" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4799 17.2595C16.2732 17.4662 15.9929 17.5823 15.7006 17.5823V17.5823C15.4083 17.5823 15.128 17.4662 14.9213 17.2595L13.6548 15.993C13.1272 15.4877 13.0614 14.6675 13.5017 14.0845C13.7487 13.7797 14.1132 13.5939 14.505 13.573C14.8967 13.5521 15.279 13.6982 15.5569 13.9751L15.5608 13.9789L15.7006 14.1187L15.7864 14.033C16.2917 13.5054 17.1119 13.4396 17.6949 13.8799C17.9997 14.1269 18.1855 14.4914 18.2064 14.8832C18.2273 15.2749 18.0812 15.6572 17.8043 15.9351L17.8005 15.939L16.4799 17.2595Z" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.2298 11.6668C18.9793 8.21709 17.3595 4.68711 14.2556 3.00557C11.1516 1.32403 7.31006 1.89538 4.82981 4.40743C2.34956 6.91948 1.82721 10.768 3.54816 13.8503C5.26911 16.9326 8.81943 18.5072 12.2593 17.7138" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};

export const NewVisitIcon = () => {

    return (
        <>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18 15.3649C18 16.0841 17.4158 16.6666 16.6958 16.6666H4.30417C3.58417 16.6666 3 16.0841 3 15.3649V4.63492C3 3.91575 3.58417 3.33325 4.30417 3.33325H16.6958C17.4158 3.33325 18 3.91575 18 4.63492V15.3649Z" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3 6.66667H18" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14.6667 9.98332H11.3333" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.2917 13.3417H11.3333" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 11.675H8.83333" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.16667 10.0166V13.3416" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};

export const NewWhiteboard = ({ height = "20", width = "21"}) => {

    return (
        <>
            <svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2.99689" y="2.49707" width="15.0062" height="2.50104" rx="1" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <rect x="3.83057" y="4.99805" width="13.3389" height="9.17049" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.0031 14.1685H2.99689" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 14.1685V15.8358" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <ellipse cx="10.5" cy="17.0865" rx="1.25052" ry="1.25052" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};

export const NewLabsIcon = () => {

    return (
        <>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.33332 4V6.78133C9.33332 7.13467 9.47399 7.474 9.72399 7.724L12.9427 10.9427C13.1927 11.1927 13.3333 11.532 13.3333 11.8853V12.6667C13.3333 13.4033 12.7367 14 12 14H3.99999C3.26332 14 2.66666 13.4033 2.66666 12.6667V11.8853C2.66666 11.532 2.80732 11.1927 3.05732 10.9427L6.27599 7.724C6.52599 7.474 6.66666 7.13467 6.66666 6.78133V4" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.66667 2H9.33333C9.70133 2 10 2.29867 10 2.66667V3.33333C10 3.70133 9.70133 4 9.33333 4H6.66667C6.29867 4 6 3.70133 6 3.33333V2.66667C6 2.29867 6.29867 2 6.66667 2Z" stroke="#1D2433" stroke-width="1.6599" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2.78665 11.3333H13.2133" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.54666 7.33333H9.45333" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};


export const NewVaccinesIcon = () => {

    return (
        <>
           <svg x="0px" y="0px" viewBox="0 0 24 24" width="16" height="16"><path d="M23.89 23.36 18.898 18.368l0.794 -0.794a0.375 0.375 0 0 0 0 -0.53l-0.763 -0.763 1.418 -1.418a0.375 0.375 0 0 0 0 -0.53L9.783 3.767a0.375 0.375 0 0 0 -0.53 0l-2.477 2.477L4.622 4.092l2.477 -2.477a0.375 0.375 0 0 0 0 -0.53L6.125 0.11a0.375 0.375 0 0 0 -0.53 0L0.11 5.595a0.375 0.375 0 0 0 0 0.53l0.974 0.974a0.374 0.374 0 0 0 0.265 0.11 0.374 0.374 0 0 0 0.265 -0.11l2.477 -2.477 2.153 2.153 -2.477 2.477a0.375 0.375 0 0 0 0 0.53L11.318 17.333a0.375 0.375 0 0 0 0.53 -0.53l-0.249 -0.249 1.056 -1.056a0.375 0.375 0 1 0 -0.53 -0.53l-1.056 1.056 -1.347 -1.347 1.523 -1.523a0.375 0.375 0 1 0 -0.53 -0.53l-1.523 1.523 -1.347 -1.347 1.056 -1.056a0.375 0.375 0 1 0 -0.53 -0.53l-1.056 1.056 -1.347 -1.347 1.523 -1.523a0.375 0.375 0 1 0 -0.53 -0.53l-1.523 1.523 -0.874 -0.874 3.412 -3.412 2.102 2.102a0.374 0.374 0 0 0 0.265 0.11 0.374 0.374 0 0 0 0.265 -0.11 0.375 0.375 0 0 0 0 -0.53l-2.102 -2.102 1.013 -1.013 10.034 10.034 -1.013 1.013 -7.073 -7.073a0.375 0.375 0 1 0 -0.53 0.53L18.008 16.14l-1.993 1.993 -1.418 1.418 -1.12 -1.12 1.523 -1.523a0.375 0.375 0 0 0 -0.53 -0.53l-1.523 1.523 -0.225 -0.225a0.375 0.375 0 0 0 -0.53 0.53l0.49 0.49 0 0 0 0 1.65 1.65a0.374 0.374 0 0 0 0.265 0.11 0.374 0.374 0 0 0 0.265 -0.11l1.418 -1.418 0.763 0.763a0.374 0.374 0 0 0 0.265 0.11 0.374 0.374 0 0 0 0.265 -0.11l0.794 -0.794 4.992 4.992c0.073 0.073 0.169 0.11 0.265 0.11s0.192 -0.037 0.265 -0.11a0.375 0.375 0 0 0 0 -0.53M1.349 6.304l-0.444 -0.444 4.955 -4.955 0.444 0.444zm16.753 11.798 0 0 0 0 -0.794 0.794 -0.498 -0.498 1.588 -1.588 0.498 0.498z"></path>
           </svg>
        </>
    );

};
export const NewPhysicalDrugIcon = () => {

    return (
        <>
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9833 8.86667V7.73333C11.9833 7.32832 11.655 7 11.25 7H9.41665C9.01164 7 8.68332 7.32832 8.68332 7.73333V8.86667" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <rect x="6.66666" y="8.8667" width="7.33333" height="5.13333" rx="1.65" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.33334 11.3333H11.3333" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.3333 12.3333V10.3333" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 7.33325H4C2.89543 7.33325 2 8.22868 2 9.33325V9.99992" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="6" cy="3.33325" r="2" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};
export const NewIncidentIcon = () => {

    return (
        <>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="10.5" cy="4.84367" rx="2.76042" ry="2.76042" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.8333 17.5V10.3687" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 14.1667H8.41666C7.7263 14.1667 7.16666 14.7263 7.16666 15.4167V16.6667C7.16666 17.1269 7.53975 17.5 7.99999 17.5H15.5C16.4205 17.5 17.1667 16.7538 17.1667 15.8334V14.4557C17.1713 12.5344 15.8599 10.8597 13.9935 10.4035C11.6956 9.8655 9.3044 9.8655 7.00646 10.4035C5.14006 10.8597 3.82864 12.5344 3.83323 14.4557L3.83333 16.6667" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.5 10V17.5" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    );

};
export const NewNotificationIcon = () => {

    return (
        <>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.49401 13V9C6.49401 5.686 9.18301 3 12.5 3C15.817 3 18.506 5.686 18.506 9V13C18.506 13.986 18.954 14.919 19.723 15.537L20.032 15.785C20.949 16.521 20.428 18 19.252 18H5.74801C4.57201 18 4.05101 16.521 4.96801 15.785L5.27701 15.537C6.04701 14.919 6.49401 13.986 6.49401 13Z" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M11 21H14" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </>
    );

};
export const NewProfileIcon = () => {

    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="profile" width="20" height="20">
                <circle cx="16" cy="8.5" r="5.5" fill="#1D2433"></circle>
                <path fill="#1D2433" d="M16 15a9 9 0 0 0-9 9v4a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-4a9 9 0 0 0-9-9Z"></path>
                <path fill="#1D2433" d="M16 3v11a5.5 5.5 0 0 0 0-11Z"></path>
                <path fill="#1D2433" d="M16 15v14h8a1 1 0 0 0 1-1v-4a9 9 0 0 0-9-9Z"></path>
            </svg>
        </>
    );

};
export const NewChangePasswordIcon = () => {

    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="password" width="20" height="20">
                <path fill="#1D2433" d="M19,10H5V8A7,7,0,0,1,19,8ZM7,8H17A5,5,0,0,0,7,8Z"></path>
                <path fill="#1D2433" d="M19,20H5a4,4,0,0,1-4-4V12A4,4,0,0,1,5,8H19a4,4,0,0,1,4,4v4A4,4,0,0,1,19,20ZM5,10a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z">
                </path>
                <path fill="#1D2433" d="M19,9H5a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V12A3,3,0,0,0,19,9ZM6,15a1,1,0,1,1,1-1A1,1,0,0,1,6,15Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,10,15Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,14,15Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,18,15Z">
                </path>
            </svg>
        </>
    );

};
export const NewChangeUIIcon = () => {

    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" id="new" viewBox="0 0 24 24" fill="">
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="m23 12 -2.44 -2.78 0.34 -3.685 -3.61 -0.815 -1.89 -3.18L12 3l-3.4 -1.46 -1.89 3.18 -3.61 0.815 0.34 3.685L1 12l2.44 2.78 -0.34 3.685 3.61 0.815 1.89 3.18L12 21l3.4 1.46 1.89 -3.18 3.61 -0.815 -0.34 -3.685zM13 17h-2v-2h2zm0 -4h-2V7h2z"></path>
            </svg>
        </>
    );

};
export const NewLogoutIcon = () => {

    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" id="logout">
                <path fill="#1D2433" fill-rule="evenodd" d="M3 13H15V11H3V13Z" clip-rule="evenodd"></path>
                <path fill="#1D2433" fill-rule="evenodd" d="M5.79282 7.79291L2.29282 11.2929C1.90229 11.6834 1.90229 12.3166 2.29282 12.7071L5.79282 16.2071L7.20703 14.7929L4.41414 12L7.20703 9.20712L5.79282 7.79291Z" clip-rule="evenodd"></path>
                <path fill="#1D2433" fill-rule="evenodd" d="M8 4C8 3.44772 8.44772 3 9 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H9C8.44772 21 8 20.5523 8 20V17H10V19H20V5H10V7H8V4Z" clip-rule="evenodd"></path>
            </svg>
        </>
    );

};
export const NewQrIcon = () => {

    return (
        <>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.6667 14.0001H12C13.1046 14.0001 14 13.1047 14 12.0001V10.6667"
                            stroke="#1D2433"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.66666 5.66659H11.3333"
                            stroke="#1D2433"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M2 8.00011L14 8.00005"
                            stroke="#1D2433"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.66666 10.3333H11.3333"
                            stroke="#1D2433"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10.6667 2H12C13.1046 2 14 2.89543 14 4V5.33333"
                            stroke="#1D2433"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M2 10.6667V12.0001C2 13.1047 2.89543 14.0001 4 14.0001H5.33333"
                            stroke="#1D2433"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M2 5.33333V4C2 2.89543 2.89543 2 4 2H5.33333"
                            stroke="#1D2433"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
        </>
    );

};
export const NewAddVisitIcon = () => {

    return (
        <>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.99999 10.3334V7.66675"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M9.33332 9.00008H6.66666"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M4.99999 2V4"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M11 2V4"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <rect
                              x="2"
                              y="3"
                              width="12"
                              height="11"
                              rx="3"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
        </>
    );

};
export const NewAddPatientIcon = () => {

    return (
        <>
                      <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14 7.33333V10.6667C14 12.5076 12.5076 14 10.6667 14H5.33333C3.49238 14 2 12.5076 2 10.6667V5.33333C2 3.49238 3.49238 2 5.33333 2H8.66667"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M11.3333 3.33407H14"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12.6659 4.66667V2"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <circle
                              cx="7.99998"
                              cy="6.33342"
                              r="1.66667"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5 10.6667C5.26461 10.0597 5.86373 9.66706 6.52596 9.66675H9.47404C10.1363 9.66706 10.7354 10.0597 11 10.6667"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
        </>
    );

};
export const NewDetailViewIcon = () => {

    return (
        <>
                <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.7683 8.59714C12.7442 9.57297 12.7442 11.1571 11.7683 12.1346C10.7925 13.1105 9.20834 13.1105 8.23084 12.1346C7.255 11.1588 7.255 9.57464 8.23084 8.59714C9.20834 7.61964 10.7917 7.61964 11.7683 8.59714"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M2.5 10.3639C2.5 9.81468 2.62667 9.27135 2.87167 8.77052V8.77052C4.13417 6.18968 6.92417 4.53052 10 4.53052C13.0758 4.53052 15.8658 6.18968 17.1283 8.77052V8.77052C17.3733 9.27135 17.5 9.81468 17.5 10.3639C17.5 10.913 17.3733 11.4564 17.1283 11.9572V11.9572C15.8658 14.538 13.0758 16.1972 10 16.1972C6.92417 16.1972 4.13417 14.538 2.87167 11.9572V11.9572C2.62667 11.4564 2.5 10.913 2.5 10.3639Z"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
        </>
    );

};
export const NewChartIcon = () => {

    return (
        <>
                     <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 2.86377H5C3.61929 2.86377 2.5 3.98306 2.5 5.36377V7.86377"
                            stroke="#323232"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M13.3333 17.8638H15C16.3807 17.8638 17.5 16.7445 17.5 15.3638V12.8638"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.59878 11.7246H7.1226C6.84672 11.7246 6.58872 11.5881 6.43356 11.36L6.00398 10.7284C5.84882 10.5003 5.59082 10.3638 5.31494 10.3638H3.76544C3.07509 10.3638 2.51544 10.9234 2.51544 11.6138V16.6138C2.51544 17.3041 3.07509 17.8638 3.76544 17.8638H9.59878C10.2891 17.8638 10.8488 17.3041 10.8488 16.6138V12.9746C10.8488 12.2842 10.2891 11.7246 9.59878 11.7246Z"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <ellipse
                            cx="13.3333"
                            cy="5.36385"
                            rx="3.33333"
                            ry="3.33333"
                            stroke="#323232"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M17.5 9.53046L15.69 7.72046"
                            stroke="#323232"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
        </>
    );

};
export const NewRemoveIcon = () => {

    return (
        <>
                  <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.4483 17.8637H6.54831C5.67581 17.8637 4.95081 17.1904 4.88581 16.3195L4.13831 6.19702H15.8333L15.1108 16.3154C15.0483 17.1879 14.3225 17.8637 13.4483 17.8637V17.8637Z"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9.99998 9.53052V14.5305"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3.33331 6.19718H16.6666"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M14.1666 6.1971L13.3225 3.94544C13.0783 3.2946 12.4566 2.86377 11.7616 2.86377H8.23831C7.54331 2.86377 6.92165 3.2946 6.67748 3.94544L5.83331 6.1971"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12.8583 9.53052L12.5 14.5305"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.14167 9.53052L7.50001 14.5305"
                            stroke="#1D2433"
                            strokeOpacity="0.8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
        </>
    );

};
export const NewMeatBallIcon = ({ iconDropDownList = [] }) => {
    const [pendingDeleteItem, setPendingDeleteItem] = useState(null);

    const handleDropdownItemClick = (item) => {
      if (item?.isDelete) {
        setPendingDeleteItem(item);
        return;
      }
      if (typeof item?.clickHandler === "function") {
        item.clickHandler();
      }
    };

    const handleDeleteConfirm = () => {
      if (typeof pendingDeleteItem?.clickHandler === "function") {
        pendingDeleteItem.clickHandler();
      }
      setPendingDeleteItem(null);
    };

    return (
      <>
      {pendingDeleteItem &&
        createPortal(
          <Alert
            onDelete={handleDeleteConfirm}
            onClose={() => setPendingDeleteItem(null)}
            {...(pendingDeleteItem?.contentTitle
              ? { contentTitle: pendingDeleteItem.contentTitle }
              : {})}
            {...(pendingDeleteItem?.content
              ? { content: pendingDeleteItem.content }
              : {})}
            {...(pendingDeleteItem?.contentType
              ? { type: pendingDeleteItem.contentType }
              : {})}
          />,
          document.body
        )}
      <div className="dropdown" style={{ position: 'static' }}>
        {/* Dropdown Toggle Button */}
        <a
          className="btn btn-icon px-1 btn-transparent-dark noarrow"
          type="button"
          data-bs-toggle="dropdown"
          data-bs-boundary="viewport"
          data-bs-offset="0,5"
          aria-expanded="false"
        >
          {/* SVG Icon */}
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.4189 10.182C15.4189 10.4122 15.2323 10.5988 15.0021 10.5988C14.7719 10.5988 14.5853 10.4122 14.5853 10.182C14.5853 9.95176 14.7719 9.76514 15.0021 9.76514C15.2323 9.76514 15.4189 9.95176 15.4189 10.182"
              stroke="#1D1917"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.4168 10.182C10.4168 10.4122 10.2302 10.5988 9.99997 10.5988C9.76976 10.5988 9.58313 10.4122 9.58313 10.182C9.58313 9.95176 9.76976 9.76514 9.99997 9.76514C10.2302 9.76514 10.4168 9.95176 10.4168 10.182"
              stroke="#1D1917"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.41473 10.182C5.41473 10.4122 5.22811 10.5988 4.99789 10.5988C4.76768 10.5988 4.58105 10.4122 4.58105 10.182C4.58105 9.95176 4.76768 9.76514 4.99789 9.76514C5.22811 9.76514 5.41473 9.95176 5.41473 10.182"
              stroke="#1D1917"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
  
        {/* Dropdown Menu */}
        <ul className="dropdown-menu dropdown-menu-end px-0">
          {iconDropDownList.map((item, index) => (
            <li
              key={index}
              className="dropdown-item d-flex align-items-center gap-2"
              onClick={() => handleDropdownItemClick(item)}
            >
              <span className="flex-shrink-0" title={item.label}>
                <Icons type={item.iconType} color={item.iconColor} />
              </span>
              {item.label}
            </li>
          ))}
        </ul>

      </div>
      </>
    );
  };
export const NewStatusIcons = (props) => {
  const { type, size = 16 ,fontSize='16px' } = props;

  const renderIcon = () => {
      switch(type) {
          case 'green':
              return (
<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.3009 6.20337L10.0042 12.5L6.85669 9.3517"
    stroke="#0DAC59"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C5.8575 17.5 2.5 14.1425 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C11.2108 2.5 12.3508 2.79417 13.3633 3.30333"
    stroke="#0DAC59"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


              );
              case 'greensmall':
              return (
<svg
  width="16"
  height="16"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.3009 6.20337L10.0042 12.5L6.85669 9.3517"
    stroke="#0DAC59"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C5.8575 17.5 2.5 14.1425 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C11.2108 2.5 12.3508 2.79417 13.3633 3.30333"
    stroke="#0DAC59"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


              );
          case 'red':
              return (
<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    cx="9.99995"
    cy="10.0002"
    r="7.50312"
    stroke="#E02D3C"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M8.07056 8.07068C8.26808 7.21938 9.04344 6.62913 9.9166 6.66537C10.8938 6.61124 11.7316 7.35591 11.7924 8.33273C11.7924 9.58651 9.99997 10.0001 9.99997 10.8338"
    stroke="#E02D3C"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.1042 13.1263C10.1042 13.1839 10.0575 13.2305 9.99997 13.2305C9.94242 13.2305 9.89576 13.1839 9.89576 13.1263C9.89576 13.0688 9.94242 13.0221 9.99997 13.0221"
    stroke="#E02D3C"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M9.99999 13.0222C10.0575 13.0222 10.1042 13.0689 10.1042 13.1264"
    stroke="#E02D3C"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

              );
              case 'yellow':
                  return (
<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    cx="9.99995"
    cy="10.0002"
    r="7.50312"
    stroke="#E4B200"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M8.07056 8.07068C8.26808 7.21938 9.04344 6.62913 9.9166 6.66537C10.8938 6.61124 11.7316 7.35591 11.7924 8.33273C11.7924 9.58651 9.99997 10.0001 9.99997 10.8338"
    stroke="#E4B200"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.1042 13.1263C10.1042 13.1839 10.0575 13.2305 9.99997 13.2305C9.94242 13.2305 9.89576 13.1839 9.89576 13.1263C9.89576 13.0688 9.94242 13.0221 9.99997 13.0221"
    stroke="#E4B200"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M9.99999 13.0222C10.0575 13.0222 10.1042 13.0689 10.1042 13.1264"
    stroke="#E4B200"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


                  );
              case 'blue':
                  return (
<svg
  width="20"
  height="21"
  viewBox="0 0 20 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    cx="9.99995"
    cy="10.0913"
    r="7.50312"
    stroke="#174ADD"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M8.07056 8.16175C8.26808 7.31045 9.04344 6.7202 9.9166 6.75644C10.8938 6.70231 11.7316 7.44697 11.7924 8.4238C11.7924 9.67758 9.99997 10.0912 9.99997 10.9248"
    stroke="#174ADD"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.1042 13.2174C10.1042 13.2749 10.0575 13.3216 9.99997 13.3216C9.94242 13.3216 9.89576 13.2749 9.89576 13.2174C9.89576 13.1598 9.94242 13.1132 9.99997 13.1132"
    stroke="#174ADD"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M9.99999 13.1133C10.0575 13.1133 10.1042 13.1599 10.1042 13.2175"
    stroke="#174ADD"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

                  );
                  case 'patientdetails':
                  return (
                      <svg xmlns="http://www.w3.org/2000/svg" height={'18px'} width={'18px'}  fill='#6698e2' viewBox="0 -960 960 960"  ><path d="M624-384q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM384-144v-63q0-28 14.5-51t38.5-35q43-21 90-32t97-11q50 0 97 11t90 32q24 12 38.5 35t14.5 51v63H384Zm73-72h334q-30-23-72-35.5T624-264q-53 0-95 12.5T457-216Zm167-240q20.4 0 34.2-13.8Q672-483.6 672-504q0-20.4-13.8-34.2Q644.4-552 624-552q-20.4 0-34.2 13.8Q576-524.4 576-504q0 20.4 13.8 34.2Q603.6-456 624-456Zm0-48Zm0 288ZM144-396v-72h288v72H144Zm0-300v-72h432v72H144Zm293 150H144v-72h326q-12 16-20.11 33.78Q441.77-566.44 437-546Z"/>
                      </svg>
  
                  );
                  case 'visitdetails':
                  return (
                      <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height={'14px'} fill='#fdaf3d' width={'14px'} data-name="Layer 1" viewBox="0 0 24 24">
                      <polygon points="21.414 5 17 5 17 .586 21.414 5"/>
                      <path d="M15,7V0H5c-1.657,0-3,1.343-3,3V24H22V7h-7Zm-5.5-2c1.105,0,2,.895,2,2s-.895,2-2,2-2-.895-2-2,.895-2,2-2Zm-3.5,7c0-1.103,.897-2,2-2h3c1.103,0,2,.897,2,2v1h-2v-1h-3v1h-2v-1Zm12,5H6v-2h12v2Zm0,4H6v-2h12v2Z"/>
                    </svg>
  
                  );
                  case 'companydetails':
                  return (
                      <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height={'14px'} width={'14px'} fill='#6bb69b' data-name="Layer 1" viewBox="0 0 24 24">
                      <path d="m16.5,15.5c0-1.379,1.121-2.5,2.5-2.5s2.5,1.121,2.5,2.5-1.121,2.5-2.5,2.5-2.5-1.121-2.5-2.5Zm7.5,6.5v2h-10v-2c0-1.654,1.346-3,3-3h4c1.654,0,3,1.346,3,3Zm-12,2H0V3C0,1.346,1.346,0,3,0h10c1.654,0,3,1.346,3,3v9.17c-.914.824-1.5,2.005-1.5,3.33,0,.7.174,1.354.46,1.945-1.741.783-2.96,2.526-2.96,4.555v2Zm-3-17h3v-2h-3v2Zm0,4h3v-2h-3v2Zm0,4h3v-2h-3v2Zm0,4h3v-2h-3v2Zm-2-2h-3v2h3v-2Zm0-4h-3v2h3v-2Zm0-4h-3v2h3v-2Zm0-4h-3v2h3v-2Z"/>
                    </svg>
                  );
                  case 'labdetails':
                  return (
                      <svg xmlns="http://www.w3.org/2000/svg" height={'14px'} fill='#e2d466' width={'14px'} id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                      <path d="M22.5,18c0-.46-.089-.895-.218-1.313l1.416-.816-.998-1.733-1.411,.813c-.605-.652-1.393-1.125-2.289-1.33v-1.621h-2v1.621c-.896,.205-1.685,.678-2.289,1.33l-1.411-.813-.998,1.733,1.416,.816c-.129,.418-.218,.853-.218,1.313s.089,.895,.218,1.313l-1.416,.816,.998,1.733,1.411-.813c.605,.652,1.393,1.125,2.289,1.33v1.621h2v-1.621c.896-.205,1.685-.678,2.289-1.33l1.411,.813,.998-1.733-1.416-.816c.129-.418,.218-.853,.218-1.313Zm-4.5,1.5c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5,.673,1.5,1.5-.673,1.5-1.5,1.5ZM7,9.04V2h-2V0h12V2h-2v7.04c.29,.253,.731,.652,1.251,1.158-2.581,.576-4.69,2.397-5.664,4.802H1.758c1.746-2.728,4.296-5.131,5.242-5.96Zm5.721,14.96H3.044c-.117-.042-3.044-1.108-3.044-4.143,0-.951,.258-1.884,.678-2.857H10.069c-.041,.328-.069,.661-.069,1,0,2.393,1.056,4.534,2.721,6Z"/>
                      </svg>
                  );
                  case 'Testdetails':
                      return (
                          <i className='fas fa-file-medical' style={{fontSize:'14px',color:'#009fff'}} aria-hidden="true"></i>
                      );
                  case 'newTestResultsIcon':
                    return(
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 6V10.172C14 10.702 14.211 11.211 14.586 11.586L19.414 16.414C19.789 16.789 20 17.298 20 17.828V19C20 20.105 19.105 21 18 21H6C4.895 21 4 20.105 4 19V17.828C4 17.298 4.211 16.789 4.586 16.414L9.414 11.586C9.789 11.211 10 10.702 10 10.172V6" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 3H14C14.552 3 15 3.448 15 4V5C15 5.552 14.552 6 14 6H10C9.448 6 9 5.552 9 5V4C9 3.448 9.448 3 10 3Z" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.6599" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.17969 17H19.8197" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.82031 11H14.1803" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                    );
                    case 'newCompanyDetails':
                    return(
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 21V12C3 11.4477 3.44772 11 4 11H7" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 8.00012V4.50148C11 4.00951 11.2412 3.54881 11.6456 3.26859C12.05 2.98836 12.566 2.92424 13.0267 3.09698L20.3511 5.84365C20.7414 5.99001 21 6.36313 21 6.77998V21.0001" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 21V9C7 8.44772 7.44772 8 8 8H15C15.5523 8 16 8.44772 16 9V21" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 21H2" stroke="#1D2433" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 17.5H13" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 14.5H13" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 11.5H13" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                    )
          default:
              return null;
      }
  };

  return (
      <>
          {renderIcon()}
      </>
  );
  };
  export const NewBillingTableIcon = (props) => {
    const {size,color}=props;
    return (
    <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6675 7.86273V7.02905" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6675 12.865V13.6987" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.22114 12.2694C9.43475 12.6367 9.82622 12.8641 10.2511 12.8677H11.1648C11.7558 12.8672 12.2538 12.4264 12.326 11.8398C12.3982 11.2532 12.022 10.7048 11.4487 10.561L9.88619 10.1685C9.31294 10.0247 8.9367 9.47628 9.0089 8.8897C9.0811 8.30312 9.57911 7.86229 10.1701 7.86182H11.0838C11.5079 7.86476 11.899 8.09108 12.1128 8.4573" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6666 2.86084C14.8105 2.86084 18.1697 6.2201 18.1697 10.364C18.1697 14.5078 14.8105 17.8671 10.6666 17.8671C6.52276 17.8671 3.1635 14.5078 3.1635 10.364C3.1635 6.2201 6.52276 2.86084 10.6666 2.86084" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6666 2.86084C14.8105 2.86084 18.1697 6.2201 18.1697 10.364C18.1697 14.5078 14.8105 17.8671 10.6666 17.8671C6.52276 17.8671 3.1635 14.5078 3.1635 10.364C3.1635 6.2201 6.52276 2.86084 10.6666 2.86084" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
   );
  };
  NewBillingTableIcon.defaultProps = {
    size: 24,
    color:"#0623C1",
  };
  export const NewFollowUpIcon = (props) => {
    const {size,className}=props;
    return (
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99992 12.9166V9.58331" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.6666 11.25H8.33325" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.24992 2.5V5" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.7499 2.5V5" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <rect x="2.5" y="3.75" width="15" height="13.75" rx="3" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>      


   );
  };
  NewFollowUpIcon.defaultProps = {
    size: 20,     
    className:""
  };

  export const NewAddPhysicalIcon = (props) => {
    const {size,className}=props;
    return (
      <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11.9833 8.86667V7.73333C11.9833 7.32832 11.655 7 11.25 7H9.41665C9.01164 7 8.68332 7.32832 8.68332 7.73333V8.86667"
        stroke="#1D2433"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6.66666"
        y="8.8667"
        width="7.33333"
        height="5.13333"
        rx="1.65"
        stroke="#1D2433"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33334 11.3333H11.3333"
        stroke="#1D2433"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3333 12.3333V10.3333"
        stroke="#1D2433"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 7.33325H4C2.89543 7.33325 2 8.22868 2 9.33325V9.99992"
        stroke="#1D2433"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="6"
        cy="3.33325"
        r="2"
        stroke="#1D2433"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
   );
  };
  NewAddPhysicalIcon.defaultProps = {
    size: 16,
    className:""
  };
  export const NoRecords = () => {

    return (
        <>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.0001 16.001H9.49211C8.73611 16.001 8.00811 16.287 7.45311 16.8L7.38911 16.86C7.03711 17.186 6.76311 17.586 6.58511 18.032L6.23511 18.911" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.1859 13.1859C14.5309 12.7009 15.4999 11.4349 15.4999 9.92092C15.4999 7.98792 13.9329 6.41992 11.9989 6.41992C10.4849 6.41992 9.21889 7.38892 8.73389 8.73492" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.96009 7.96094C2.26509 11.3349 2.81909 15.5499 5.63509 18.3659C8.45209 21.1829 12.6681 21.7359 16.0421 20.0399" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.63403 5.63505V5.63505C9.15003 2.11905 14.85 2.11905 18.365 5.63505C21.88 9.15005 21.88 14.849 18.366 18.365" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 20L4 4" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </>
    );

};
export const NewPrintIcon = () =>{
  return (
    <>
     <svg fill="#000000" height="16" width="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enable-background="new 0 0 64 64">	
      <path d="M57.7881012,14.03125H52.5v-8.0625c0-2.2091999-1.7909012-4-4-4h-33c-2.2091999,0-4,1.7908001-4,4v8.0625H6.2119002		C2.7871001,14.03125,0,16.8183498,0,20.2431507V46.513649c0,3.4248009,2.7871001,6.2119026,6.2119002,6.2119026h2.3798995		c0.5527,0,1-0.4472008,1-1c0-0.5527-0.4473-1-1-1H6.2119002C3.8896,50.7255516,2,48.8359489,2,46.513649V20.2431507		c0-2.3223,1.8896-4.2119007,4.2119002-4.2119007h51.5762024C60.1102982,16.03125,62,17.9208508,62,20.2431507V46.513649		c0,2.3223-1.8897018,4.2119026-4.2118988,4.2119026H56c-0.5527992,0-1,0.4473-1,1c0,0.5527992,0.4472008,1,1,1h1.7881012		C61.2128983,52.7255516,64,49.9384499,64,46.513649V20.2431507C64,16.8183498,61.2128983,14.03125,57.7881012,14.03125z		 M13.5,5.96875c0-1.1027999,0.8971996-2,2-2h33c1.1027985,0,2,0.8972001,2,2v8h-37V5.96875z"/>	
      <path d="M44,45.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,47.0302505,20,47.0302505h24		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,45.0322495,44,45.0322495z"/>	
      <path d="M44,52.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,54.0302505,20,54.0302505h24		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,52.0322495,44,52.0322495z"/>	
      <circle cx="7.9590998" cy="21.8405495" r="2"/>	
      <circle cx="14.2856998" cy="21.8405495" r="2"/>	
      <circle cx="20.6121998" cy="21.8405495" r="2"/>	
      <path d="M11,62.03125h42v-26H11V62.03125z M13.4036999,38.4349518h37.1925964v21.1925964H13.4036999V38.4349518z"/>
     </svg>
    </>
  )
}
export const NewPatientDetailsIcon = () =>{
  return (
    <>
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M16.8001 16.7996C15.2601 16.7996 13.9418 16.2513 12.8451 15.1546C11.7484 14.0579 11.2001 12.7396 11.2001 11.1996C11.2001 9.65961 11.7484 8.34128 12.8451 7.24461C13.9418 6.14794 15.2601 5.59961 16.8001 5.59961C18.3401 5.59961 19.6584 6.14794 20.7551 7.24461C21.8518 8.34128 22.4001 9.65961 22.4001 11.1996C22.4001 12.7396 21.8518 14.0579 20.7551 15.1546C19.6584 16.2513 18.3401 16.7996 16.8001 16.7996ZM8.4001 27.9996C7.6301 27.9996 6.97116 27.7257 6.4233 27.1778C5.8745 26.629 5.6001 25.9696 5.6001 25.1996V24.0796C5.6001 23.2863 5.8045 22.5569 6.2133 21.8914C6.62116 21.2269 7.16343 20.7196 7.8401 20.3696C9.28676 19.6463 10.7568 19.1035 12.2501 18.7414C13.7434 18.3802 15.2601 18.1996 16.8001 18.1996C18.3401 18.1996 19.8568 18.3802 21.3501 18.7414C22.8434 19.1035 24.3134 19.6463 25.7601 20.3696C26.4368 20.7196 26.979 21.2269 27.3869 21.8914C27.7957 22.5569 28.0001 23.2863 28.0001 24.0796V25.1996C28.0001 25.9696 27.7262 26.629 27.1783 27.1778C26.6295 27.7257 25.9701 27.9996 25.2001 27.9996H8.4001ZM8.4001 25.1996H25.2001V24.0796C25.2001 23.8229 25.1362 23.5896 25.0083 23.3796C24.8795 23.1696 24.7101 23.0063 24.5001 22.8896C23.2401 22.2596 21.9684 21.7869 20.6851 21.4714C19.4018 21.1569 18.1068 20.9996 16.8001 20.9996C15.4934 20.9996 14.1984 21.1569 12.9151 21.4714C11.6318 21.7869 10.3601 22.2596 9.1001 22.8896C8.8901 23.0063 8.72116 23.1696 8.5933 23.3796C8.4645 23.5896 8.4001 23.8229 8.4001 24.0796V25.1996ZM16.8001 13.9996C17.5701 13.9996 18.2295 13.7252 18.7783 13.1764C19.3262 12.6285 19.6001 11.9696 19.6001 11.1996C19.6001 10.4296 19.3262 9.77068 18.7783 9.22281C18.2295 8.67401 17.5701 8.39961 16.8001 8.39961C16.0301 8.39961 15.3712 8.67401 14.8233 9.22281C14.2745 9.77068 14.0001 10.4296 14.0001 11.1996C14.0001 11.9696 14.2745 12.6285 14.8233 13.1764C15.3712 13.7252 16.0301 13.9996 16.8001 13.9996Z" 
       fill="#4A505C"/>
    </svg>

     
    </>
  )
}
export const VisitHistoryIcon = () => {
  return (
    <>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.125 9.375C13.125 9.02982 12.8452 8.75 12.5 8.75H11.25V7.5C11.25 7.15482 10.9702 6.875 10.625 6.875H9.375C9.02982 6.875 8.75 7.15482 8.75 7.5V8.75H7.5C7.15482 8.75 6.875 9.02982 6.875 9.375V10.625C6.875 10.9702 7.15482 11.25 7.5 11.25H8.75V12.5C8.75 12.8452 9.02982 13.125 9.375 13.125H10.625C10.9702 13.125 11.25 12.8452 11.25 12.5V11.25H12.5C12.8452 11.25 13.125 10.9702 13.125 10.625V9.375Z" stroke="#4A505C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.9167 4.58334V2.08334" stroke="#4A505C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.4167 2.08332H12.9167" stroke="#4A505C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.16666 2.1279C5.17916 2.54424 2.13031 5.87231 2.06409 9.88094C1.99786 13.8896 4.93512 17.3165 8.90668 17.8644C12.8783 18.4122 16.6336 15.9084 17.6551 12.0315C18.6765 8.15466 16.6425 4.12547 12.9167 2.64517" stroke="#4A505C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

     
    </>
  )
}
export const ChartIcon = () => {
  return (
    <>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M7.08325 13.3334H9.16659" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         <path d="M9.99992 10.8334H7.08325" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         <path d="M8.33341 7.91669V5.41669" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         <path d="M9.58325 6.66667H7.08325" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0834 17.5H17.0834C17.3135 17.5 17.5001 17.3135 17.5001 17.0833V16.745C17.4973 15.7824 16.7177 15.0027 15.7551 15H13.4117C12.4492 15.0027 11.6695 15.7824 11.6667 16.745V17.0833C11.6667 17.3135 11.8533 17.5 12.0834 17.5Z" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         <circle cx="14.5834" cy="11.25" r="1.66667" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         <path d="M17.4999 7.5V7.0911C17.4999 6.42807 17.2365 5.79219 16.7677 5.32335L14.6766 3.23223C14.2077 2.76339 13.5719 2.5 12.9088 2.5H5.83325C4.45254 2.5 3.33325 3.61929 3.33325 5V15C3.33325 16.3807 4.45254 17.5 5.83325 17.5H8.33325" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </>
  )
}
export const ConsentFormIcon = () => {
  return (
    <>
     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.6667 12.5V15C16.6667 16.3807 15.5474 17.5 14.1667 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5C2.5 3.61929 3.61929 2.5 5 2.5H8.33333" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.83325 13.3334H13.3333" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.83325 9.99998H8.33325" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.83325 6.66667H7.49992" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7255 9.95631V9.95631C11.8016 9.57154 10.4168 7.88231 10.4167 5.92033V4.58333C10.4167 3.43274 11.3495 2.5 12.5001 2.5H15.8334C16.984 2.5 17.9167 3.43274 17.9167 4.58333V5.92032C17.9167 7.88226 16.532 9.57147 14.6081 9.95628H14.608C14.3167 10.0145 14.0168 10.0146 13.7255 9.95631V9.95631Z" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.125 5.83335L13.9583 6.66669L15.2083 5.41669" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     </svg>

    </>
  )
} 

// Used by NewCalendar/CalendarHeader/CalendarViewTypes "Today" toolbar button.
export const NewTodayIcon = () => {
  return (
    <>
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.00008 2V4"
          stroke="#1D1917"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0001 2V4"
          stroke="#1D1917"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 6.66659H2"
          stroke="#1D1917"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="2"
          y="3"
          width="12"
          height="11"
          rx="3"
          stroke="#1D1917"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const HistoricalVisitListIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        shape-rendering="geometricPrecision"
        text-rendering="geometricPrecision"
        image-rendering="optimizeQuality"
        fill-rule="evenodd"
        clip-rule="evenodd"
        viewBox="0 0 512 513.11"
      >
        <path
          fill-rule="nonzero"
          d="M210.48 160.8c0-14.61 11.84-26.46 26.45-26.46s26.45 11.85 26.45 26.46v110.88l73.34 32.24c13.36 5.88 19.42 21.47 13.54 34.82-5.88 13.35-21.47 19.41-34.82 13.54l-87.8-38.6c-10.03-3.76-17.16-13.43-17.16-24.77V160.8zM5.4 168.54c-.76-2.25-1.23-4.64-1.36-7.13l-4-73.49c-.75-14.55 10.45-26.95 25-27.69 14.55-.75 26.95 10.45 27.69 25l.74 13.6a254.258 254.258 0 0136.81-38.32c17.97-15.16 38.38-28.09 61.01-38.18 64.67-28.85 134.85-28.78 196.02-5.35 60.55 23.2 112.36 69.27 141.4 132.83.77 1.38 1.42 2.84 1.94 4.36 27.86 64.06 27.53 133.33 4.37 193.81-23.2 60.55-69.27 112.36-132.83 141.39a26.24 26.24 0 01-12.89 3.35c-14.61 0-26.45-11.84-26.45-26.45 0-11.5 7.34-21.28 17.59-24.92 7.69-3.53 15.06-7.47 22.09-11.8.8-.66 1.65-1.28 2.55-1.86 11.33-7.32 22.1-15.7 31.84-25.04.64-.61 1.31-1.19 2-1.72 20.66-20.5 36.48-45.06 46.71-71.76 18.66-48.7 18.77-104.46-4.1-155.72l-.01-.03C418.65 122.16 377.13 85 328.5 66.37c-48.7-18.65-104.46-18.76-155.72 4.1a203.616 203.616 0 00-48.4 30.33c-9.86 8.32-18.8 17.46-26.75 27.29l3.45-.43c14.49-1.77 27.68 8.55 29.45 23.04 1.77 14.49-8.55 27.68-23.04 29.45l-73.06 9c-13.66 1.66-26.16-7.41-29.03-20.61zM283.49 511.5c20.88-2.34 30.84-26.93 17.46-43.16-5.71-6.93-14.39-10.34-23.29-9.42-15.56 1.75-31.13 1.72-46.68-.13-9.34-1.11-18.45 2.72-24.19 10.17-12.36 16.43-2.55 39.77 17.82 42.35 19.58 2.34 39.28 2.39 58.88.19zm-168.74-40.67c7.92 5.26 17.77 5.86 26.32 1.74 18.29-9.06 19.97-34.41 3.01-45.76-12.81-8.45-25.14-18.96-35.61-30.16-9.58-10.2-25.28-11.25-36.11-2.39a26.436 26.436 0 00-2.55 38.5c13.34 14.2 28.66 27.34 44.94 38.07zM10.93 331.97c2.92 9.44 10.72 16.32 20.41 18.18 19.54 3.63 36.01-14.84 30.13-33.82-4.66-15-7.49-30.26-8.64-45.93-1.36-18.33-20.21-29.62-37.06-22.33C5.5 252.72-.69 262.86.06 274.14c1.42 19.66 5.02 39 10.87 57.83z"
        ></path>
      </svg>
    </>
  );
}


